import { signIn, signOut, useSession } from 'next-auth/react'
import { useState } from 'react'
import { Button } from 'components/common/Button'
import {
  SsoButtons,
  StyledAppleLogo,
  StyledGoogleLogo
} from './SignInModal.style'

interface SSOButtonsProps {
  signInRedirect: {
    callbackUrl: string
    redirect?: boolean
  }
}

export const SSOButtons = ({ signInRedirect }: SSOButtonsProps) => {
  const [loading, setLoading] = useState(false)
  const session = useSession()
  const handleSignIn = async (callback: () => void) => {
    setLoading(true)
    if (session.status === 'authenticated') {
      await signOut({ redirect: false })
    }
    callback()
  }
  return (
    <SsoButtons>
      <Button
        largeIcon
        icon={<StyledGoogleLogo />}
        disabled={loading}
        onClick={() => handleSignIn(() => signIn('google', signInRedirect))}
      />
      <Button
        largeIcon
        disabled={loading}
        icon={<StyledAppleLogo />}
        onClick={() => handleSignIn(() => signIn('apple', signInRedirect))}
      />
    </SsoButtons>
  )
}
